import { fetch } from '@atlassian/eoc-fetch';

import {
	type CreateUpdateMaintenanceParams,
	type Maintenance,
	type MaintenanceResponse,
	type UserRightsResponse,
} from '../../common/types';

export const getMaintenance = (teamId: string | null | undefined) => {
	return fetch<MaintenanceResponse>(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};

export const deleteMaintenance = (teamId: string | undefined, id: string) => {
	return fetch(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};

export const cancelMaintenance = (teamId: string | undefined, id: string) => {
	return fetch<Maintenance>(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
		method: 'PATCH',
	});
};
export const changeDateAndTime = (teamId: string | undefined, id: string, endDate: number) => {
	return fetch<Maintenance>(
		`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`,
		{
			method: 'PATCH',
			body: { endDate },
		},
	);
};

export const getMaintenanceUserRights = (teamId: string | null | undefined) => {
	return fetch<UserRightsResponse>(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};

export const createMaintenance = (payload: CreateUpdateMaintenanceParams, teamId?: string) => {
	const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
	return fetch<Maintenance>(url, { method: 'POST', body: payload });
};

export const updateMaintenance = (
	payload: CreateUpdateMaintenanceParams,
	id: string,
	teamId?: string,
) => {
	const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
	return fetch<Maintenance>(url, { method: 'PUT', body: payload });
};
